import type { IconProps } from './types';

export const ChevronUpIcon: React.FC<IconProps> = (props) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth={1.5}
            {...props}
        >
            <path d="M16.9502 13.501L12.0004 8.80862L7.0507 13.501" stroke="currentColor" />
        </svg>
    );
};
